import { ProviderType } from '../../models/ProviderDetails';
import { Constants } from '../Constants';
import { ConstantsRoutes } from '../ConstantsRoutes';

const onlineProviderLatLong = '00.00000';

export const getSectionType = (providerType: ProviderType): string =>
  providerType === ProviderType.PRACTITIONER
    ? Constants.SEARCH_TYPES.PROVIDER
    : Constants.SEARCH_TYPES.FACILITY;

export const getEffectiveNetworkStatus = (
  isStaffModelPcp: boolean,
  isStaffModelPCPInNetwork: boolean | undefined,
  isNetworkStatus: boolean
): boolean => (isStaffModelPcp ? !!isStaffModelPCPInNetwork : isNetworkStatus);

export const getNetworkStatusIcon = (isNetworkStatus: boolean): string =>
  isNetworkStatus ? '$success1' : '';

export const getIsOnlineProvider = (
  providerLocations: any[] | undefined
): boolean =>
  providerLocations?.some(
    (location) =>
      location?.longitude === onlineProviderLatLong &&
      location?.latitude === onlineProviderLatLong
  ) ?? false;

export const getBhIconValue = (
  coverage: string | undefined,
  specialitiesIds: string[],
  bhProviderIcons: any[],
  bhSpecialtyCodes: any[],
  getBhIcon: (...args: any[]) => string
): string =>
  coverage === 'B'
    ? getBhIcon(specialitiesIds, [], bhProviderIcons, bhSpecialtyCodes)
    : '';

export const getDisableAllCtas = (
  isPcP: boolean,
  isFuturePcpCard: boolean,
  isOON: boolean,
  isSuppressed: boolean
): boolean => {
  if (!isPcP && !isFuturePcpCard) return false;
  return isOON || isSuppressed;
};

export const getProviderDetailsPath = (
  providerType: string,
  urlParams: string
): string => {
  if (
    providerType?.toLowerCase() === ProviderType.PRACTITIONER?.toLowerCase()
  ) {
    return `${ConstantsRoutes.PROVIDER_DETAILS.path}${urlParams}`;
  }
  if (
    providerType?.toLowerCase() === ProviderType.MEDICAL_GROUP?.toLowerCase()
  ) {
    return `${ConstantsRoutes.PROVIDER_GROUP_DETAILS.path}${urlParams}`;
  }
  return `${ConstantsRoutes.FACILITY_DETAILS.path}${urlParams}`;
};
